/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
/* eslint-disable react/no-unescaped-entities */
import React, { useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import {
  Applogo,
  Avatar_02,
  Avatar_01,
  headerlogo,
  lnEnglish,
} from "../../Routes/ImagePath";
import ProfileMenu from "./ProfileMenu"; // Import the ProfileMenu component
const Header = (props) => {
  const [profile, setProfile] = useState(false);
  const navigate = useNavigate();
  const baseUrl = process.env.REACT_APP_BASE_URL;
  const cdnUrl = process.env.REACT_APP_CDN_URL;
  const profilePic = localStorage.getItem('profilepic');
  const submitButtonRef = useRef(null);
  const businessdate = localStorage.getItem("posbusiness_date");
  // Removed unused moment import and formatting (not used here)

  const handleProfile = () => setProfile(true);

  const handleAppClick = (app) => {
    setProfile(false);
switch (app) {
      case 'office':
        navigate('./employee-dashboard');
        break;
      case 'hms':
        navigate('/hospitality');
        break;
      case 'feedback':
        navigate('/feedback/feedback-settings');
        break;
      case 'booking-engine':
        navigate('/booking-engine/configuration'); // Updated to module-specific path
        break;
      case 'pos':
        alert('NetShine POS is available but not added to your plan. Please upgrade your plan.');
        break;
      default:
        break;
    }
  };

  const handleLogout = () => {
    setProfile(false);
localStorage.clear();
    sessionStorage.clear();
    navigate(baseUrl);
  };

  const handleAccountClick = () => {
    setProfile(false);
    setTimeout(() => {
      navigate("/booking-engine/account-settings"); // Updated to module-specific if needed; revert if shared
    }, 300);
  };

  const handleApiClick = () => {
    setProfile(false);
    setTimeout(() => {
      navigate("/api-settings");
    }, 300);
  };

  const handleManageOrgClick = () => {
    setProfile(false);
    setTimeout(() => {
      navigate("hospitality/manage-property"); // Kept as-is; update if booking-engine specific
    }, 300);
  };

  const { t } = { t: (key) => key }; // Fallback translation function

  const Credencial = localStorage.getItem("credencial");
  const Value = JSON.parse(Credencial);
  const UserName = Value?.email?.split("@")[0];
  const ProfileName = localStorage.getItem("username");
  const useremail = localStorage.getItem("useremail");
  const gender = localStorage.getItem("gender");

  return (
    <div className="header" style={{ right: "0px" }}>
      <div className="header-left">
        <Link to="/booking-engine/" className="logo"> {/* Updated logo link */}
          <img src={headerlogo} width={150} height={50} alt="img" />
        </Link>
        <Link to="/booking-engine/" className="logo2"> {/* Updated logo link */}
          <img src={Applogo} width={40} height={40} alt="img" />
        </Link>
      </div>
      <div
        className="header-container"
        style={{
          display: "flex",
          justifyContent: "flex-end",
          alignItems: "center",
          padding: "0 20px",
          height: "100%",
        }}
      >
        <div className="profile-section" style={{ textAlign: "right", marginLeft: "20px" }}>
          <li className="nav-item dropdown has-arrow main-drop">
            <Link
              to="#"
              className="dropdown-toggle nav-link"
              onClick={(event) => {
                event.preventDefault();
                handleProfile();
              }}
            >
              <span className="user-img me-1">
                <div className="profile-image">
                  <img
                    src={
                      profilePic && profilePic.trim() !== "" && profilePic !== "null"
                        ? `${cdnUrl}/${profilePic}`
                        : gender === "male"
                        ? Avatar_02
                        : Avatar_01
                    }
                    alt="User Avatar"
                    className="user-avatar"
                    style={{
                      width: "40px",
                      height: "40px",
                      borderRadius: "50%",
                      objectFit: "cover",
                    }}
                  />
                </div>
              </span>
            </Link>
          </li>
        </div>
      </div>
<ProfileMenu
        isOpen={profile}
        onClose={() => setProfile(false)}
        profilePic={profilePic}
        gender={gender}
        ProfileName={ProfileName}
        useremail={useremail}
        flagImage={lnEnglish}
        handleLogout={handleLogout}
        handleAccountClick={handleAccountClick}
        handleApiClick={handleApiClick}
        handleManageOrgClick={handleManageOrgClick}
        handleAppClick={handleAppClick}
      />
      <div className="dropdown mobile-user-menu">
        <Link
          to="#"
          className="nav-link dropdown-toggle"
          data-bs-toggle="dropdown"
          aria-expanded="false"
        >
          <i className="fa fa-ellipsis-v" />
        </Link>
        <div className="dropdown-menu dropdown-menu-end dropdown-menu-right">
          <Link className="dropdown-item" to="/profile">
            My Profile
          </Link>
          <Link className="dropdown-item" to="hospitality/manage-property">
            Settings
          </Link>
          <Link className="dropdown-item" to="#" onClick={handleLogout}>
            Logout
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Header;